import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { BANNER_CONSTANTS } from './banner-constants';
var BannerAdapter = /** @class */ (function (_super) {
    __extends(BannerAdapter, _super);
    function BannerAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(component, BANNER_CONSTANTS.selectors.BANNER);
        return _this;
    }
    BannerAdapter.prototype.addRootClass = function (name) {
        this._rootElement.classList.add(name);
    };
    BannerAdapter.prototype.removeRootClass = function (name) {
        this._rootElement.classList.remove(name);
    };
    BannerAdapter.prototype.addDismissButtonAttribute = function (name, value) {
        if (value === void 0) { value = ''; }
        this.tcwIconButtonDismiss.setAttribute(name, value);
    };
    BannerAdapter.prototype.removeDismissButtonAttribute = function (name) {
        this.tcwIconButtonDismiss.removeAttribute(name);
    };
    BannerAdapter.prototype.addDismissEventListener = function (event, callback) {
        this.buttonDismiss.addEventListener(event, callback);
    };
    BannerAdapter.prototype.removeDismissEventListener = function (event, callback) {
        this.buttonDismiss.removeEventListener(event, callback);
    };
    Object.defineProperty(BannerAdapter.prototype, "tcwIconButtonDismiss", {
        get: function () {
            if (!this._tcwIconButtonDismiss) {
                this._tcwIconButtonDismiss = getShadowElement(this._component, BANNER_CONSTANTS.selectors.TCW_DISMISS_BUTTON);
            }
            return this._tcwIconButtonDismiss;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerAdapter.prototype, "buttonDismiss", {
        get: function () {
            if (!this._buttonDismiss) {
                this._buttonDismiss = getShadowElement(this._component, BANNER_CONSTANTS.selectors.DISMISS_BUTTON);
            }
            return this._buttonDismiss;
        },
        enumerable: true,
        configurable: true
    });
    return BannerAdapter;
}(BaseAdapter));
export { BannerAdapter };
